/**
 * REACT_APP_AI_CHAT_ENABLED — build-time master switch for the AI support
 * chat button (see ai-chat-widget.tsx). Whether it's shown to a given POM
 * Master (always, unchanged) or a given customer (per-org `chatSupport.mode`
 * setting) is a separate, runtime decision made in AiChatWidget itself —
 * this flag only controls whether the feature exists in this deployment at
 * all.
 *
 * Default OFF. When the flag is absent, empty, or anything other than a
 * truthy string, nothing under src/components/ai-chat renders or runs: no
 * floating button, no requests. The Zendesk launcher is never touched either way.
 *
 * Read at call time rather than module load so tests can toggle it between
 * cases. CRA inlines `process.env.REACT_APP_*` at build time, which works
 * the same way inside a function body.
 *
 * Try it locally:
 *   REACT_APP_AI_CHAT_ENABLED=true npm start
 */
const TRUTHY_VALUES = new Set(['true', '1', 'yes', 'on']);

export function isAiChatEnabled(): boolean {
  const raw = process.env.REACT_APP_AI_CHAT_ENABLED;
  return typeof raw === 'string' && TRUTHY_VALUES.has(raw.trim().toLowerCase());
}
